import { render, staticRenderFns } from "./languageBar.vue?vue&type=template&id=7c5a769a&scoped=true"
import script from "./languageBar.vue?vue&type=script&lang=js"
export * from "./languageBar.vue?vue&type=script&lang=js"
import style0 from "./languageBar.vue?vue&type=style&index=0&id=7c5a769a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5a769a",
  null
  
)

export default component.exports